import React, { useState, useCallback } from 'react';
import './FaultSecondPage/FaultSecondPageCustom.css'
import DashboardMain from '../DashboardMain/DashboardMain';
import FaultSecondPageCharts from './FaultSecondPage/FaultSecondPageChartsLine';
import FaultSecondPageDataBars from './FaultSecondPage/FaultSecondPageDataBars';
import FaultSecondPageFilters from './FaultSecondPage/FaultSecondPageFilters';
import FaultSecondPageKpis from './FaultSecondPage/FaultSecondPageKpis';
import FaultSecondPageChartsBidir from './FaultSecondPage/FaultSecondPageChartsBidir';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates';

// import * as $ from 'jquery';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

export default function Faultanalysis(props) {
    const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
    const [secondPageState, setSecondPageState] = useState({
        startDate: gloablfilter.startDate,
        endDate: gloablfilter.endDate,
        vin_num: "MAT486022NZF15168",
    });
    const onreset = (data) => {
        setSecondPageState({
            startDate: gloablfilter.startDate,
            endDate: gloablfilter.endDate,
            vin_num: "",
        });
    }

    const filterSubmited = useCallback((data) => {
        setSecondPageState(data);
    }, []);

    return (
        <DashboardMain>
            <FaultSecondPageFilters onsubmit={filterSubmited} secondPageState={secondPageState} onreset={onreset} />
            <div className="container-fluid">
                <FaultSecondPageKpis gloablfilter={secondPageState} />
                <section className="graphs sec2Charts">
                    <FaultSecondPageDataBars gloablfilter={secondPageState} />
                    <div className="row mt-4 mb-3">
                        <FaultSecondPageCharts gloablfilter={secondPageState} />
                        <FaultSecondPageChartsBidir gloablfilter={secondPageState} />
                    </div>
                </section>
            </div>
        </DashboardMain>
    )
}
